var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HeaderUserInfoContent"},[(_vm.getUserInfo)?_c('div',[_vm._v(" Welcome "+_vm._s(_vm.getUserInfo.email)+" "),_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }